import React from 'react'
import AppBarCartolang from './Navigation/AppBarCartolang'

const HeaderCartolang = ({callBackFunction,  }) => {
    return (
        <AppBarCartolang callBackFunction={callBackFunction} />
    )
}
export default HeaderCartolang